import Skeleton from '@mui/material/Skeleton';
import { Box } from 'shared/mui/Box';

type Props = {
  rowsCount: number;
};

export const GatewayRuleMappingPercentEditDialogSkeleton: React.FC<Props> = ({ rowsCount }) => (
  <>
    {Array.from({ length: rowsCount }).map((_, i) => (
      <Box display="flex" flexDirection="column" gap={2} key={i}>
        <Skeleton height={20} variant="text" width={200} />
        <Skeleton height={40} sx={{ width: '100%' }} variant="rounded" />
      </Box>
    ))}
  </>
);
